import React from 'react';
import { IconButton } from 'theme-ui';

function Icon() {
  return (
    <IconButton>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 16 16"
        stroke="currentColor"
      >
        <path
          fill="currentColor"
          d="M6.667 2.667h-4c-.733 0-1.327.6-1.327 1.333l-.007 8c0 .733.6 1.333 1.334 1.333h10.666c.734 0 1.334-.6 1.334-1.333V5.333c0-.733-.6-1.333-1.333-1.333H8L6.667 2.667z"
        />
      </svg>
    </IconButton>
  );
}

export default Icon;
